import { useState } from 'react';
import { logger } from '@/utils/logger';
import { SessionKey } from '@/types/storage';

export function useSessionState<T>(
  key: SessionKey,
  defaultValue: T
): [T, (value: T) => void] {
  const [state, setStateRaw] = useState<T>(() => {
    try {
      const item = sessionStorage.getItem(key);
      if (item === null) return defaultValue;
      return JSON.parse(item) as T;
    } catch (err) {
      logger.warn(`[useSessionState] Failed to read "${key}":`, err as Error);
      return defaultValue;
    }
  });

  const setState = (value: T) => {
    try {
      sessionStorage.setItem(key, JSON.stringify(value));
    } catch (err) {
      logger.warn(`[useSessionState] Failed to write "${key}":`, err as Error);
    }
    setStateRaw(value);
  };

  return [state, setState];
}
